const NEXT_KEY = 'codeninja.next';

export function isSafeNextPath(path) {
  if (!path || typeof path !== 'string') return false;
  if (!path.startsWith('/')) return false;
  if (path.startsWith('//') || path.includes('://')) return false;
  return path.startsWith('/assessments/');
}

export function rememberNextPath(path) {
  if (isSafeNextPath(path)) {
    sessionStorage.setItem(NEXT_KEY, path);
  }
}

export function consumeNextPath(fallback = '/dashboard') {
  const stored = sessionStorage.getItem(NEXT_KEY);
  sessionStorage.removeItem(NEXT_KEY);
  return isSafeNextPath(stored) ? stored : fallback;
}

export function nextFromSearch(search) {
  const params = new URLSearchParams(search || '');
  const next = params.get('next');
  if (isSafeNextPath(next)) {
    rememberNextPath(next);
    return next;
  }
  return null;
}

export function loginPathWithNext(next) {
  if (!isSafeNextPath(next)) return '/login';
  return `/login?next=${encodeURIComponent(next)}`;
}

export function registerPathWithNext(next) {
  if (!isSafeNextPath(next)) return '/register';
  return `/register?next=${encodeURIComponent(next)}`;
}
